module.exports = __webpack_public_path__ + "static/img/3000.65ea7f98.png";